import {cn, useStaticAssetsUrl} from "@tinct/core-utils";

export type TinctIconProps = {
  className?: string;
};


export const TinctIcon = ({className}: TinctIconProps) => {
  const assetsUrl = useStaticAssetsUrl();
  return (
    <img
      src={`${assetsUrl}/img/tinct-logo-icon.png`}
      alt=""
      className={cn("h-full w-auto", className)}
    />
  );
};
